export const required = value => (!!value ? undefined : 'Необходимое поле')

export const email = value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Неверный формат e-mail' : undefined

export const number = value => (value && isNaN(Number(value)) ? 'Не является числом' : undefined)

export const biggerThanZero = value => (value > 0 ? undefined : 'Значение должно быть больше нуля')

export const phoneNumber = value => (value && !/^\+?[0-9]\d{1,14}$/i.test(value) ? 'Неверный формат' : undefined)



// WEBPACK FOOTER //
// ./src/utils/validationUtils.js